import React from 'react'
import { PrimaryLink } from 'jl-design-system/elements/link/Link'
import styles from './GenericError.scss'

type Props = {
  body: string
  ctaText: string
}

export default function GenericError({ body, ctaText }: Props): JSX.Element {
  return (
    <div data-testid="generic-error">
      <p className={styles.body} data-testid="error-body">
        {body}
      </p>

      <div>
        <PrimaryLink to="/#homepage" external className={styles.cta} data-testid="error-cta">
          {ctaText}
        </PrimaryLink>
      </div>
    </div>
  )
}
